import { fetchRequest } from './fetchRequest';
const { REACT_APP_ENV } = process.env;
const debounce = (fn, delay) => {
  var timer = null;
  return function () {
    let args = arguments;
    timer && clearTimeout(timer);
    timer = setTimeout(() => {
      fn.apply(this, [...args]);
    }, delay)
  }
}

const throttle = (fn, delay) => {
  var timer = null;
  return function () {
    let args = arguments;
    if (timer) return;
    timer = setTimeout(() => {
      fn.apply(this, [...args]);
      timer = null;
    }, delay)
  }
}

function sleep(time = 2000) {
  return new Promise(resolve => {
    setTimeout(resolve, time);
  })
}

function setHtmlFontSize() {
  let deviceWidth = document.documentElement.clientWidth;
  let deviceHeight = document.documentElement.clientHeight;
  if (Math.abs(window.orientation) === 90) deviceWidth = deviceHeight;  //横屏状态
  document.getElementsByTagName("html")[0].style.fontSize = deviceWidth / 37.5 + "px";
}

// 域名检测
const checkDomain = async(url = '') => {
  // 美课域名不备份
  if (REACT_APP_ENV === 'metcom' || REACT_APP_ENV === 'test3') {
    return true;
  }
  try {
    console.log('checkDomain', url)
    const response = await fetchRequest(`${url}/_sys_/connectivity`, {
      method: 'POST'
    });
    const res = await response.json();
    if (res?.status === 'UP') {
      return true;
    }
  } catch (error) {
    console.log('check url error:', error);
    return false;
  }
}

export { debounce, throttle, sleep, setHtmlFontSize, checkDomain };